app.service('warrantyUpsellingConfigurator', function (modal, validate, _, stackedModal, accountConfig, loading, upsellingContext, message, upsellingWarranties) {

	let selectedWarranties = []; // { itemId, productPlu, warrantyId, quantity, firstInstallmentPrice, subscriptionPrice }
	let config;
	let $self, $warranties, $summary, $submit, $totalFirstInstallmentWorth, $totalSubscriptionWorth;

	function init() {
		setElements();
		setEvents();
		render();
	}

	function setElements() {
		$self = $('#modal-warranty-upselling-configurator');
		$warranties = $('.warranty-row', $self);
		$summary = $('.upselling-summary', $self);
		$submit = $('.submit-button', $self);
		$totalFirstInstallmentWorth = $('.total-first-installment-worth .js-total-worth', $self);
		$totalSubscriptionWorth = $('.total-subscription-worth .js-total-worth', $self);

		config = accountConfig.getData();
	}

	function setEvents() {
		$self
			.on('change', '.js-select-warranty', toggleWarranty)
			.on('change', '.select3-input', updateWarrantyQuantity)
			.on("click", ".js-show-warranty-description", showWarrantyDescription)
			.on("click", ".js-user-settings", handleUserSettingsRedirect);

		$(document).on('closing', '#modal-warranty-upselling-configurator', function () {
			setInitialState();
		});

		validate.task('warrantyUpsellingForm', {
			$form: $('form', $self),
			submitHandler
		});
	}

	function submitHandler() {
		let data = {
			orderNumber: config.orderNumber,
			items: selectedWarranties.map(item => ({
				productPlu: item.productPlu,
				warrantyId: item.warrantyId,
				warrantyQuantity: item.quantity,
			}))
		}

		loading.start();

		$.ajax({
			url: $('form', $self).attr('action'),
			method: 'POST',
			dataType: 'json',
			contentType: 'application/json',
			data: JSON.stringify(data)
		})
			.then(function (response) {
				if (response.status === "FAILURE") {
					if (response.failureReason === "RESERVATION_FAILURE") {
						loading.stop();

						message.get("subscription-warranty-upselling-reservation-error")
							.then(content => {
								modal.generate({
									id: 'reservation-failure-modal',
									content,
									callbackClose() {
										loading.reload();
									}
								})
							});
					}
					if (response.failureReason === "REGISTRATION_FAILURE") {
						loading.reload();
					}
				} else {
					upsellingWarranties.subscribeUpsellingWarranty(response.id);
				}
			})
			.fail(function () {
				loading.stop();
				modal.alert("Błąd wewnętrzny systemu.");
			});
	}

	function handleUserSettingsRedirect() {
		upsellingContext.setup();
		loading.redirect("/customer-password.bhtml");
	}

	function showWarrantyDescription() {
		const id = $(this).closest('.warranty-row').data('warranty-id')
		stackedModal.push(modal.open(`warranty-upselling-description-${id}`));
	}

	function toggleWarranty() {
		let $warranty = $(this).closest('.warranty-row');
		const warrantyId = +$(this).val();
		const firstInstallmentPrice = +$warranty.data('first-installment-price');
		const subscriptionPrice = +$warranty.data('subscription-price');
		const productPlu = +$warranty.data('plu');
		const quantity = +$warranty.find('.select3-input').val() || 1;
		const itemId = +$warranty.data('item-id');

		$warranty.toggleClass('is-selected', $(this).is(':checked'));

		const index = selectedWarranties.findIndex(warranty => warranty.itemId === itemId);

		if (index !== -1) {
			selectedWarranties = [...selectedWarranties.filter(warranty => warranty.itemId !== itemId)];
		} else {
			selectedWarranties = [
				...selectedWarranties,
				{
					itemId,
					warrantyId,
					productPlu,
					quantity,
					firstInstallmentPrice,
					subscriptionPrice
				}
			];
		}
		render();
	}

	function updateWarrantyQuantity() {
		let $warranty = $(this).closest('.warranty-row');
		const quantity = +$(this).val();
		const itemId = +$warranty.data('item-id');

		const index = selectedWarranties.findIndex(warranty => warranty.itemId === itemId);

		if (index !== -1) {
			selectedWarranties = [
				...selectedWarranties.filter(warranty => warranty.itemId !== itemId),
				$.extend(selectedWarranties[index], {quantity}, true)
			];
		}
		render();
	}

	function render() {

		renderWarrantyPrices();

		if (selectedWarranties.length) {
			renderSummaryPrices();
		} else {
			$submit.prop('disabled', true);
			$summary.removeClass('has-items');
		}
	}

	function renderWarrantyPrices() {
		$warranties.each(function () {
			const firstInstallmentPrice = +$(this).data('first-installment-price');
			const subscriptionPrice = +$(this).data('subscription-price');
			const quantity = +$(this).find('.select3-input').val() || 1;

			const firstInstallmentWorth = Math.round(firstInstallmentPrice * quantity * 100) / 100;
			const subscriptionWorth = Math.round(subscriptionPrice * quantity * 100) / 100;

			let $firstInstallmentWorth = $(this).find('.js-first-installment-worth');
			let $subscriptionWorth = $(this).find('.js-subscription-worth');

			$firstInstallmentWorth.text(_.formatPrice(firstInstallmentWorth));
			$subscriptionWorth.text(`Potem ${_.formatPrice(subscriptionWorth)} / mies.`);
		});
	}

	function renderSummaryPrices() {
		$submit.removeAttr('disabled');
		$summary.addClass('has-items');

		let totalFirstInstallmentWorth = selectedWarranties.reduce((total, warranty) => total + (warranty.firstInstallmentPrice * warranty.quantity), 0);
		let totalSubscriptionWorth = selectedWarranties.reduce((total, warranty) => total + (warranty.subscriptionPrice * warranty.quantity), 0);

		$totalFirstInstallmentWorth.text(_.formatPrice(Math.round(totalFirstInstallmentWorth * 100) / 100));
		$totalSubscriptionWorth.text(`${_.formatPrice(Math.round(totalSubscriptionWorth * 100) / 100)} / mies.`);
	}

	function show() {
		stackedModal.push(modal.open('warranty-upselling-configurator'));
	}

	function isActive() {
		return modal.isOpen('warranty-upselling-configurator');
	}

	function setInitialState() {
		selectedWarranties = [];
		$('input[type=checkbox]', $self).prop('checked', false);
		$('.warranty-row', $self).removeClass('is-selected');
		$('.product-list-item', $self).removeClass('is-selected');

		$('.js-select-warranty-quantity', $self).each(function () {
			let $quantityOptions = $('.select3-option', $(this));
			$('.select3-input', $(this)).val($quantityOptions.length).change();
		});

		validate.resetForm($('form', $self));
		render();
	}

	return {
		init,
		show,
		isActive
	};
});
